"use client";

export const runtime = "edge";

import { useEffect } from "react";
import Link from "next/link";
import { ArrowRight, ChevronRight } from "lucide-react";
import { useAppDispatch, useAppSelector } from "@/hooks/useStore";
import { getProgramList } from "@/store/controller/program.controller";
import { getIcon } from "../../components/landing/iconMap";
import { PROGRAM_THEME } from "../../components/landing/theme";

export default function ProgramListPage() {
  const dispatch = useAppDispatch();
  const programs = useAppSelector((state) => state.program.list);

  useEffect(() => {
    dispatch(getProgramList({ limit: 100 }));
  }, [dispatch]);

  return (
    <div className="pt-24 sm:pt-28">
      <div className="bg-green-800 py-12 sm:py-16 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-2 text-green-300 text-sm mb-4">
            <Link href="/" className="hover:text-white transition-colors">
              Beranda
            </Link>
            <ChevronRight size={14} />
            <span className="text-white">Program Unggulan</span>
          </div>
          <h1 className="text-3xl sm:text-4xl font-extrabold text-white mb-3">Program Unggulan</h1>
          <p className="text-green-200 max-w-xl">
            Kurikulum terpadu yang memadukan ilmu agama dan ilmu umum, dirancang untuk menghasilkan lulusan yang
            kompetitif dan berkarakter.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {programs.map((program) => {
            const Icon = getIcon(program.icon);
            const theme = PROGRAM_THEME[program.color_theme] ?? PROGRAM_THEME.green;
            return (
              <Link
                key={program.slug}
                href={`/program/${program.slug}`}
                className={`group flex flex-col rounded-2xl border overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-1 ${theme.color}`}
              >
                {program.image ? (
                  <div className="h-48 overflow-hidden">
                    <img
                      src={program.image}
                      alt={program.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                ) : (
                  <div className={`h-48 flex items-center justify-center ${theme.iconBg}`}>
                    <Icon size={48} className="text-white/90" />
                  </div>
                )}
                <div className="p-6 flex flex-col flex-1">
                  <div className="flex items-start gap-3 mb-3">
                    <div className={`w-10 h-10 rounded-xl ${theme.iconBg} flex items-center justify-center flex-shrink-0`}>
                      <Icon size={20} className="text-white" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 flex-wrap">
                        <h2 className="font-bold text-gray-900 text-lg leading-tight">{program.title}</h2>
                        <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${theme.tagColor}`}>{program.tag}</span>
                      </div>
                    </div>
                  </div>
                  <p className="text-gray-600 text-sm leading-relaxed flex-1 mb-4">{program.description}</p>
                  <div className="pt-4 border-t border-black/5 flex items-center justify-between">
                    <span className="text-xs text-gray-400">
                      {program.teachers && program.teachers.length > 0
                        ? `${program.teachers.length} pengajar berpengalaman`
                        : ""}
                    </span>
                    <span className="inline-flex items-center gap-1 text-green-700 text-xs font-semibold group-hover:gap-2 transition-all ml-auto">
                      Detail Program <ArrowRight size={13} />
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
